import { PageHeader } from '@/components/PageHeader';
import { EnhancedMobileFeatures } from '@/components/EnhancedMobileFeatures';

export default function MobileApp() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Mobile Application"
        description="Native mobile features, PWA capabilities, and offline functionality"
      />
      <EnhancedMobileFeatures />
    </div>
  );
}